import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { Observable, map } from 'rxjs';
import { TranslateService } from 'src/app/core/translate';

@Pipe({
    name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {
    private timeZone = '+0300'
    public constructor(private translateService: TranslateService) {}

    transform(date: Date | string | number, format: string): Observable<string> {
        return this.translateService.currentLang$.pipe(
            map(lang => {
                //force date to be english
                const formattedFormat = format.replace(/h/g, 'HH').replace(/a/g, '')||format.replace(/hh/g, 'HH').replace(/a/g, '');//change format to 24 hours

                if ( date && date !== "null"  ) {
                    const result = new DatePipe('en', this.timeZone).transform(date, formattedFormat, this.timeZone)
                    return result
                } else {
                    return null;
                }
            })
        );
    }
}
